import { render, staticRenderFns } from "./EarlyClaimTotalGGTTable.vue?vue&type=template&id=1cd4012d&scoped=true&"
import script from "./EarlyClaimTotalGGTTable.vue?vue&type=script&lang=js&"
export * from "./EarlyClaimTotalGGTTable.vue?vue&type=script&lang=js&"
import style0 from "./EarlyClaimTotalGGTTable.vue?vue&type=style&index=0&id=1cd4012d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd4012d",
  null
  
)

export default component.exports